import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['sticky']

  connect() {
    this.handleScroll = this.handleScroll.bind(this)
    window.addEventListener('scroll', this.handleScroll, { passive: true })
    this.handleScroll()
  }

  disconnect() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.stickyTargets.forEach(el => {
          const rect = el.getBoundingClientRect()
          const isStuck = Math.round(rect.top) === 61
          el.classList.toggle('sticky', isStuck)
        })
        this.ticking = false
      })
      this.ticking = true
    }
  }
}
